import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "grid grid-cols-12 gap-3 md:gap-4" }
const _hoisted_2 = { class: "col-span-12 xxl:col-span-12 grid grid-cols-12 gap-6" }
const _hoisted_3 = { class: "col-span-12 mt-4" }
const _hoisted_4 = { class: "intro-y flex flex-row items-center h-auto sm:h-10" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-medium truncate" }, "Master Soal", -1)
const _hoisted_6 = { class: "ml-auto mt-2 sm:mt-0 flex flex-row items-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "hidden md:block" }, "Import Excel", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "hidden md:block" }, "Tambah", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "hidden md:block" }, "Reload Data", -1)
const _hoisted_10 = { class: "intro-y col-span-12" }
const _hoisted_11 = { class: "intro-y col-span-12 box pt-3 px-3 pb-5" }
const _hoisted_12 = { class: "grid grid-cols-8 gap-2 mb-3" }
const _hoisted_13 = { class: "flex flex-col col-span-8 md:col-span-2" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "text-base mr-auto md:mr-2 mb-2 md:mb-1 whitespace-nowrap text-left" }, " Paket : ", -1)
const _hoisted_15 = { class: "w-full flex flex-row" }
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "flex flex-col col-span-8 md:col-span-2" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", { class: "text-base mr-auto md:mr-2 mb-2 md:mb-1 whitespace-nowrap text-left" }, " Jenis : ", -1)
const _hoisted_19 = { class: "w-full flex flex-row" }
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "flex flex-col col-span-8 md:col-span-2" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", { class: "text-base mr-auto md:mr-2 mb-2 md:mb-1 whitespace-nowrap text-left" }, " Kategori : ", -1)
const _hoisted_23 = { class: "w-full flex flex-row" }
const _hoisted_24 = ["value"]
const _hoisted_25 = { class: "flex flex-col col-span-8 md:col-span-2" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", { class: "text-base mr-auto md:mr-2 mb-2 md:mb-1 whitespace-nowrap text-left" }, " Bidang : ", -1)
const _hoisted_27 = { class: "w-full flex flex-row" }
const _hoisted_28 = ["value"]
const _hoisted_29 = { class: "flex flex-col col-span-8 md:col-span-2" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", { class: "text-base mr-auto md:mr-2 mb-2 md:mb-1 whitespace-nowrap text-left" }, " Search : ", -1)
const _hoisted_31 = { class: "w-full relative text-gray-700 dark:text-gray-300" }
const _hoisted_32 = { class: "flex flex-col col-span-8 md:col-span-1" }
const _hoisted_33 = { class: "overflow-x-auto scrollbar-nav-soal" }
const _hoisted_34 = { class: "table" }
const _hoisted_35 = { class: "border-b dark:border-dark-5 whitespace-nowrap uppercase" }
const _hoisted_36 = { class: "border-b dark:border-dark-5 whitespace-nowrap" }
const _hoisted_37 = { class: "border-b dark:border-dark-5 whitespace-nowrap" }
const _hoisted_38 = { class: "border-b dark:border-dark-5 whitespace-nowrap" }
const _hoisted_39 = ["innerHTML"]
const _hoisted_40 = { class: "border-b dark:border-dark-5 whitespace-nowrap text-center" }
const _hoisted_41 = { class: "border-b dark:border-dark-5 whitespace-nowrap" }
const _hoisted_42 = { class: "border-b dark:border-dark-5 whitespace-nowrap w-20" }
const _hoisted_43 = { class: "flex flex-row" }
const _hoisted_44 = {
  key: 0,
  class: "w-full p-5 flex items-center justify-center"
}
const _hoisted_45 = /*#__PURE__*/_createElementVNode("p", { class: "text-base font-bold" }, "Tidak Ada Data Master Soal.", -1)
const _hoisted_46 = [
  _hoisted_45
]
const _hoisted_47 = {
  key: 0,
  class: "intro-y flex flex-wrap sm:flex-row sm:flex-nowrap items-center mt-6"
}
const _hoisted_48 = { class: "pagination" }
const _hoisted_49 = { class: "pagination__link" }
const _hoisted_50 = { class: "pagination__link" }
const _hoisted_51 = ["onClick"]
const _hoisted_52 = { class: "pagination__link" }
const _hoisted_53 = { class: "pagination__link" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("option", null, "5", -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("option", null, "10", -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("option", null, "25", -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("option", null, "35", -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("option", null, "50", -1)
const _hoisted_59 = [
  _hoisted_54,
  _hoisted_55,
  _hoisted_56,
  _hoisted_57,
  _hoisted_58
]
const _hoisted_60 = {
  id: "modal-data-bs",
  class: "modal p-0"
}
const _hoisted_61 = { class: "modal__content modal__content--xl" }
const _hoisted_62 = { class: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200 dark:border-dark-5" }
const _hoisted_63 = { class: "font-medium text-base mr-auto" }
const _hoisted_64 = { class: "px-3 md:px-5 py-3" }
const _hoisted_65 = { class: "flex flex-col sm:flex-row items-center mt-3" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("label", { class: "w-full sm:w-20 sm:text-right sm:mr-5" }, " Jenis Soal ", -1)
const _hoisted_67 = { class: "w-full sm:w-1/2" }
const _hoisted_68 = ["value", "onClick"]
const _hoisted_69 = { class: "flex flex-col sm:flex-row items-center mt-3" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("label", { class: "w-full sm:w-20 sm:text-right sm:mr-5" }, " Kategori Soal ", -1)
const _hoisted_71 = { class: "w-full sm:w-1/2" }
const _hoisted_72 = ["value", "onClick"]
const _hoisted_73 = { class: "flex flex-col sm:flex-row items-center mt-3" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("label", { class: "w-full sm:w-20 sm:text-right sm:mr-5" }, " Bidang Soal ", -1)
const _hoisted_75 = { class: "w-full sm:w-1/2" }
const _hoisted_76 = ["value", "onClick"]
const _hoisted_77 = { class: "flex flex-col sm:flex-row items-center mt-3" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("label", { class: "w-full sm:w-20 sm:text-right sm:mr-5" }, "Pertanyaan", -1)
const _hoisted_79 = { class: "w-full flex-1" }
const _hoisted_80 = { class: "flex flex-col sm:flex-row items-center mt-3" }
const _hoisted_81 = /*#__PURE__*/_createElementVNode("label", { class: "w-full sm:w-20 sm:text-right sm:mr-5" }, "Image Pertanyaan", -1)
const _hoisted_82 = {
  key: 0,
  class: "rounded w-full flex-1 py-3"
}
const _hoisted_83 = ["src", "alt"]
const _hoisted_84 = /*#__PURE__*/_createElementVNode("p", { class: "text-base font-bold my-3 pt-3 pb-1 text-center border-t border-gray-500" }, " List Opsi ", -1)
const _hoisted_85 = { class: "pb-3 border-b border-gray-500" }
const _hoisted_86 = { class: "flex flex-row" }
const _hoisted_87 = { class: "relative w-1/2 pr-2" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("div", { class: "absolute rounded-l w-14 md:2-16 h-full flex items-center justify-center bg-gray-100 dark:bg-dark-1 dark:border-dark-4 border text-gray-600" }, " Opsi ", -1)
const _hoisted_89 = ["onUpdate:modelValue"]
const _hoisted_90 = { class: "relative w-1/2 pl-2" }
const _hoisted_91 = /*#__PURE__*/_createElementVNode("div", { class: "absolute rounded-l w-20 h-full flex items-center justify-center bg-gray-100 dark:bg-dark-1 dark:border-dark-4 border text-gray-600" }, " Poin Opsi ", -1)
const _hoisted_92 = ["onUpdate:modelValue"]
const _hoisted_93 = { class: "flex flex-col sm:flex-row items-center mt-3" }
const _hoisted_94 = /*#__PURE__*/_createElementVNode("label", { class: "w-full sm:w-20 sm:text-right sm:mr-5" }, "Kontent Opsi", -1)
const _hoisted_95 = { class: "w-full flex-1" }
const _hoisted_96 = { class: "flex flex-col sm:flex-row items-center mt-3" }
const _hoisted_97 = /*#__PURE__*/_createElementVNode("label", { class: "w-full sm:w-20 sm:text-right sm:mr-5" }, "Image Opsi", -1)
const _hoisted_98 = ["onUpdate:modelValue"]
const _hoisted_99 = {
  key: 0,
  class: "rounded w-full flex-1 pt-3"
}
const _hoisted_100 = ["src", "alt"]
const _hoisted_101 = { class: "flex flex-col sm:flex-row items-center mt-3" }
const _hoisted_102 = /*#__PURE__*/_createElementVNode("label", { class: "w-full sm:w-20 sm:text-right sm:mr-5" }, "Pembahasan", -1)
const _hoisted_103 = { class: "w-full flex-1" }
const _hoisted_104 = { class: "flex flex-col sm:flex-row items-center mt-3" }
const _hoisted_105 = /*#__PURE__*/_createElementVNode("label", { class: "w-full sm:w-20 sm:text-right sm:mr-5" }, "Image Pembahasan", -1)
const _hoisted_106 = {
  key: 1,
  class: "rounded w-full flex-1 py-3"
}
const _hoisted_107 = ["src", "alt"]
const _hoisted_108 = { class: "flex flex-col sm:flex-row items-center mt-3" }
const _hoisted_109 = /*#__PURE__*/_createElementVNode("label", { class: "w-full sm:w-20 sm:text-right sm:mr-5" }, "Kunci Jawaban", -1)
const _hoisted_110 = { class: "px-5 py-3 text-center border-t border-gray-200 dark:border-dark-5" }
const _hoisted_111 = {
  id: "delete-modal-data-ms",
  class: "modal"
}
const _hoisted_112 = { class: "modal__content" }
const _hoisted_113 = { class: "p-5 text-center" }
const _hoisted_114 = /*#__PURE__*/_createElementVNode("div", { class: "text-3xl mt-5" }, "Apakah Anda yakin?", -1)
const _hoisted_115 = { class: "text-gray-600 mt-2" }
const _hoisted_116 = { class: "px-5 pb-8 text-center" }
const _hoisted_117 = {
  id: "modal-detail-bs",
  class: "modal p-0"
}
const _hoisted_118 = { class: "modal__content modal__content--xl" }
const _hoisted_119 = { class: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200 dark:border-dark-5" }
const _hoisted_120 = /*#__PURE__*/_createElementVNode("h2", { class: "font-medium text-base mr-auto" }, "Detail Master Soal", -1)
const _hoisted_121 = { class: "px-3 md:px-5 pt-3 pb-5" }
const _hoisted_122 = { class: "flex flex-col sm:flex-row items-center mt-3" }
const _hoisted_123 = /*#__PURE__*/_createElementVNode("label", { class: "w-full sm:w-20 sm:text-right sm:mr-5" }, " Jenis Soal ", -1)
const _hoisted_124 = { class: "flex flex-col sm:flex-row items-center mt-3" }
const _hoisted_125 = /*#__PURE__*/_createElementVNode("label", { class: "w-full sm:w-20 sm:text-right sm:mr-5" }, " Kategori Soal ", -1)
const _hoisted_126 = { class: "flex flex-col sm:flex-row items-center mt-3" }
const _hoisted_127 = /*#__PURE__*/_createElementVNode("label", { class: "w-full sm:w-20 sm:text-right sm:mr-5" }, " Bidang Soal ", -1)
const _hoisted_128 = { class: "flex flex-col sm:flex-row items-center mt-3" }
const _hoisted_129 = /*#__PURE__*/_createElementVNode("label", { class: "w-full sm:w-20 sm:text-right sm:mr-5" }, "Pertanyaan", -1)
const _hoisted_130 = ["innerHTML"]
const _hoisted_131 = { class: "flex flex-col sm:flex-row items-center mt-3" }
const _hoisted_132 = /*#__PURE__*/_createElementVNode("label", { class: "w-full sm:w-20 sm:text-right sm:mr-5" }, "Image Pertanyaan", -1)
const _hoisted_133 = {
  key: 0,
  class: "rounded w-full flex-1 py-3"
}
const _hoisted_134 = ["src", "alt"]
const _hoisted_135 = /*#__PURE__*/_createElementVNode("p", { class: "text-base font-bold my-3 pt-3 pb-1 text-center border-t border-gray-500" }, " List Opsi ", -1)
const _hoisted_136 = { class: "pb-3 border-b border-gray-500" }
const _hoisted_137 = { class: "flex flex-row" }
const _hoisted_138 = { class: "relative w-1/2 pr-2" }
const _hoisted_139 = /*#__PURE__*/_createElementVNode("div", { class: "absolute rounded-l w-14 md:2-16 h-full flex items-center justify-center bg-gray-100 dark:bg-dark-1 dark:border-dark-4 border text-gray-600" }, " Opsi ", -1)
const _hoisted_140 = ["onUpdate:modelValue"]
const _hoisted_141 = { class: "relative w-1/2 pl-2" }
const _hoisted_142 = /*#__PURE__*/_createElementVNode("div", { class: "absolute rounded-l w-20 h-full flex items-center justify-center bg-gray-100 dark:bg-dark-1 dark:border-dark-4 border text-gray-600" }, " Poin Opsi ", -1)
const _hoisted_143 = ["onUpdate:modelValue"]
const _hoisted_144 = { class: "flex flex-col sm:flex-row items-center mt-3" }
const _hoisted_145 = /*#__PURE__*/_createElementVNode("label", { class: "w-full sm:w-20 sm:text-right sm:mr-5" }, "Kontent Opsi", -1)
const _hoisted_146 = ["innerHTML"]
const _hoisted_147 = { class: "flex flex-col sm:flex-row items-center mt-3" }
const _hoisted_148 = /*#__PURE__*/_createElementVNode("label", { class: "w-full sm:w-20 sm:text-right sm:mr-5" }, "Image Opsi", -1)
const _hoisted_149 = ["onUpdate:modelValue"]
const _hoisted_150 = {
  key: 0,
  class: "rounded w-full flex-1 py-3"
}
const _hoisted_151 = ["src", "alt"]
const _hoisted_152 = { class: "flex flex-col sm:flex-row items-center mt-3" }
const _hoisted_153 = /*#__PURE__*/_createElementVNode("label", { class: "w-full sm:w-20 sm:text-right sm:mr-5" }, "Pembahasan", -1)
const _hoisted_154 = ["innerHTML"]
const _hoisted_155 = { class: "flex flex-col sm:flex-row items-center mt-3" }
const _hoisted_156 = /*#__PURE__*/_createElementVNode("label", { class: "w-full sm:w-20 sm:text-right sm:mr-5" }, "Image Pembahasan", -1)
const _hoisted_157 = {
  key: 1,
  class: "rounded w-full flex-1 py-3"
}
const _hoisted_158 = ["src", "alt"]
const _hoisted_159 = { class: "flex flex-col sm:flex-row items-center mt-3" }
const _hoisted_160 = /*#__PURE__*/_createElementVNode("label", { class: "w-full sm:w-20 sm:text-right sm:mr-5" }, "Kunci Jawaban", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FileTextIcon = _resolveComponent("FileTextIcon")!
  const _component_PlusIcon = _resolveComponent("PlusIcon")!
  const _component_RefreshCcwIcon = _resolveComponent("RefreshCcwIcon")!
  const _component_TailSelect = _resolveComponent("TailSelect")!
  const _component_SearchIcon = _resolveComponent("SearchIcon")!
  const _component_LoadingDiv = _resolveComponent("LoadingDiv")!
  const _component_FileIcon = _resolveComponent("FileIcon")!
  const _component_Tippy = _resolveComponent("Tippy")!
  const _component_Edit3Icon = _resolveComponent("Edit3Icon")!
  const _component_ChevronsLeftIcon = _resolveComponent("ChevronsLeftIcon")!
  const _component_ChevronLeftIcon = _resolveComponent("ChevronLeftIcon")!
  const _component_ChevronRightIcon = _resolveComponent("ChevronRightIcon")!
  const _component_ChevronsRightIcon = _resolveComponent("ChevronsRightIcon")!
  const _component_xIcon = _resolveComponent("xIcon")!
  const _component_CKEditor = _resolveComponent("CKEditor")!
  const _component_xCircleIcon = _resolveComponent("xCircleIcon")!
  const _component_importExcelFunc = _resolveComponent("importExcelFunc")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              class: "button bg-theme-1 hover:bg-primary text-white flex items-center w-auto mr-2",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.importExcelFunc('')))
            }, [
              _createVNode(_component_FileTextIcon, { class: "w-4 h-4 mr-0 md:mr-2" }),
              _hoisted_7
            ]),
            _createElementVNode("button", {
              class: "button bg-theme-1 hover:bg-primary text-white flex items-center w-auto mr-2",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addMS()))
            }, [
              _createVNode(_component_PlusIcon, { class: "w-4 h-4 mr-0 md:mr-2" }),
              _hoisted_8
            ]),
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getDataListMS())),
              class: "button bg-theme-1 hover:bg-primary text-white flex"
            }, [
              _createVNode(_component_RefreshCcwIcon, { class: "w-4 h-4 mr-0 md:mr-2" }),
              _hoisted_9
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_TailSelect, {
                modelValue: _ctx.dataMS.paket,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dataMS.paket) = $event)),
                onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changePaketSoal('change',$event))),
                options: {
                  classNames: 'w-full',
                }
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listPaket, (k, idx) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: idx,
                      value: k.value
                    }, _toDisplayString(k.title), 9, _hoisted_16))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_TailSelect, {
                modelValue: _ctx.dataMS.jenis,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dataMS.jenis) = $event)),
                onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.changeJenisSoal($event))),
                options: {
                  search: true,
                  classNames: 'w-full',
                }
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataMS.listJenis, (k, idx) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: idx,
                      value: k.value
                    }, _toDisplayString(k.text), 9, _hoisted_20))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("div", _hoisted_23, [
              _createVNode(_component_TailSelect, {
                modelValue: _ctx.dataMS.kategori,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.dataMS.kategori) = $event)),
                onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.changeKategoriSoal($event))),
                options: {
                  search: true,
                  classNames: 'w-full',
                }
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataMS.listKategori, (k, idx) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: idx,
                      value: k.value
                    }, _toDisplayString(k.text), 9, _hoisted_24))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _createElementVNode("div", _hoisted_27, [
              _createVNode(_component_TailSelect, {
                modelValue: _ctx.dataMS.bidang,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.dataMS.bidang) = $event)),
                onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.changeBidangSoal($event))),
                options: {
                  search: true,
                  classNames: 'w-full',
                }
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataMS.listBidang, (k, idx) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: idx,
                      value: k
                    }, _toDisplayString(k), 9, _hoisted_28))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            _createElementVNode("div", _hoisted_31, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "input w-full box pr-10 border border-gray-400 dark:bg-dark-4",
                placeholder: "Search...",
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.dataMS.search) = $event))
              }, null, 512), [
                [_vModelText, _ctx.dataMS.search]
              ]),
              _createVNode(_component_SearchIcon, {
                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.getData())),
                class: "w-4 h-4 absolute my-auto inset-y-0 mr-3 right-0 cursor-pointer"
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("button", {
              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.getDataListMS())),
              class: "button bg-theme-1 hover:bg-primary text-white w-24 ml-auto mt-2 md:ml-2 md:mt-auto mb-1"
            }, " View ")
          ])
        ]),
        _createVNode(_component_LoadingDiv, { id: "loadingBSadmin" }),
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("table", _hoisted_34, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.titleTable, (k, idx) => {
                  return (_openBlock(), _createElementBlock("th", {
                    key: idx,
                    class: "border-b-2 dark:border-dark-5 whitespace-nowrap"
                  }, _toDisplayString(k), 1))
                }), 128))
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataMS.data, (u, idx) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: idx,
                  class: _normalizeClass([idx % 2 === 0 ? 'bg-gray-200 dark:bg-dark-1' : ''])
                }, [
                  _createElementVNode("td", _hoisted_35, _toDisplayString(u.paket), 1),
                  _createElementVNode("td", _hoisted_36, _toDisplayString(u.jenis), 1),
                  _createElementVNode("td", _hoisted_37, _toDisplayString(u.kategori), 1),
                  _createElementVNode("td", _hoisted_38, _toDisplayString(u.bidang), 1),
                  _createElementVNode("td", {
                    class: "border-b dark:border-dark-5 min-w-72",
                    innerHTML: u.question
                  }, null, 8, _hoisted_39),
                  _createElementVNode("td", _hoisted_40, _toDisplayString(u.answer), 1),
                  _createElementVNode("td", _hoisted_41, _toDisplayString(_ctx.$h.formatDate(u.createdAt, 'DD MMM, YYYY HH:mm:ss')), 1),
                  _createElementVNode("td", _hoisted_42, [
                    _createElementVNode("div", _hoisted_43, [
                      _createVNode(_component_Tippy, {
                        tag: "a",
                        href: "javascript:;",
                        class: "inline-block mr-2",
                        content: "Detail",
                        onClick: ($event: any) => (_ctx.detailMSApi(u))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_FileIcon, { class: "w-6 h-6 cursor-pointer text-primary" })
                        ]),
                        _: 2
                      }, 1032, ["onClick"]),
                      _createVNode(_component_Tippy, {
                        tag: "a",
                        href: "javascript:;",
                        class: "inline-block mr-2",
                        content: "Edit",
                        onClick: ($event: any) => (_ctx.editMS(u))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Edit3Icon, { class: "w-6 h-6 cursor-pointer text-theme-12" })
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ])
                  ])
                ], 2))
              }), 128))
            ])
          ]),
          (_ctx.dataMS.data.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_44, _hoisted_46))
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.dataMS.data.length !== 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
            _createElementVNode("ul", _hoisted_48, [
              (_ctx.dataMS.page !== 1)
                ? (_openBlock(), _createElementBlock("li", {
                    key: 0,
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.goToPage(1)))
                  }, [
                    _createElementVNode("span", _hoisted_49, [
                      _createVNode(_component_ChevronsLeftIcon, { class: "w-4 h-4" })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.dataMS.page !== 1)
                ? (_openBlock(), _createElementBlock("li", {
                    key: 1,
                    onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.beforePage()))
                  }, [
                    _createElementVNode("span", _hoisted_50, [
                      _createVNode(_component_ChevronLeftIcon, { class: "w-4 h-4" })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataMS.paginate.pages, (p, idx) => {
                return (_openBlock(), _createElementBlock("li", { key: idx }, [
                  _createElementVNode("span", {
                    class: _normalizeClass([
                'pagination__link cursor-pointer',
                _ctx.dataMS.page === p ? 'pagination__link--active' : '',
              ]),
                    onClick: ($event: any) => (_ctx.goToPage(p))
                  }, _toDisplayString(p), 11, _hoisted_51)
                ]))
              }), 128)),
              (_ctx.dataMS.page !== _ctx.dataMS.paginate.totalPages)
                ? (_openBlock(), _createElementBlock("li", {
                    key: 2,
                    onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.nextPage()))
                  }, [
                    _createElementVNode("span", _hoisted_52, [
                      _createVNode(_component_ChevronRightIcon, { class: "w-4 h-4" })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.dataMS.page !== _ctx.dataMS.paginate.totalPages)
                ? (_openBlock(), _createElementBlock("li", {
                    key: 3,
                    onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.lastPage()))
                  }, [
                    _createElementVNode("span", _hoisted_53, [
                      _createVNode(_component_ChevronsRightIcon, { class: "w-4 h-4" })
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _withDirectives(_createElementVNode("select", {
              class: "w-20 input box mt-3 sm:mt-0",
              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.dataMS.pageSize) = $event)),
              onChange: _cache[19] || (_cache[19] = ($event: any) => (_ctx.changePS()))
            }, _hoisted_59, 544), [
              [_vModelSelect, _ctx.dataMS.pageSize]
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_60, [
      _createElementVNode("div", _hoisted_61, [
        _createElementVNode("div", _hoisted_62, [
          _createElementVNode("h2", _hoisted_63, _toDisplayString(_ctx.section === "add" ? "Tambah Master Soal" : "Edit Master Soal"), 1),
          _createElementVNode("a", {
            href: "javascript:;",
            class: "right-0 top-0",
            onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.$gpf.hideModal('#modal-data-bs')))
          }, [
            _createVNode(_component_xIcon, { class: "w-6 h-6 text-gray-500" })
          ])
        ]),
        _createElementVNode("div", _hoisted_64, [
          _createElementVNode("div", _hoisted_65, [
            _hoisted_66,
            _createElementVNode("div", _hoisted_67, [
              _createVNode(_component_TailSelect, {
                modelValue: _ctx.exDataMS.idJenis,
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.exDataMS.idJenis) = $event)),
                options: {
                  search: true,
                  classNames: 'w-full',
                }
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.exListMS.jenis, (ss, idx) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: idx,
                      value: ss.value,
                      onClick: ($event: any) => (_ctx.exDataMS.idJenis = ss.id)
                    }, _toDisplayString(ss.title), 9, _hoisted_68))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_69, [
            _hoisted_70,
            _createElementVNode("div", _hoisted_71, [
              _createVNode(_component_TailSelect, {
                modelValue: _ctx.exDataMS.idCategory,
                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.exDataMS.idCategory) = $event)),
                options: {
                  search: true,
                  classNames: 'w-full',
                }
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.exListMS.kategori, (ss, idx) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: idx,
                      value: ss.value,
                      onClick: ($event: any) => (_ctx.exDataMS.idCategory = ss.id)
                    }, _toDisplayString(ss.title), 9, _hoisted_72))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_73, [
            _hoisted_74,
            _createElementVNode("div", _hoisted_75, [
              _createVNode(_component_TailSelect, {
                modelValue: _ctx.exDataMS.idBidang,
                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.exDataMS.idBidang) = $event)),
                options: {
                  search: true,
                  classNames: 'w-full',
                }
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.exListMS.bidang, (ss, idx) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: idx,
                      value: ss.value,
                      onClick: ($event: any) => (_ctx.exDataMS.idCategory = ss.id)
                    }, _toDisplayString(ss.title), 9, _hoisted_76))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_77, [
            _hoisted_78,
            _createElementVNode("div", _hoisted_79, [
              _createVNode(_component_CKEditor, {
                modelValue: _ctx.exDataMS.question,
                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.exDataMS.question) = $event)),
                editor: _ctx.classicEditor,
                config: _ctx.editorConfig,
                placeholder: "Pertanyaan"
              }, null, 8, ["modelValue", "editor", "config"])
            ])
          ]),
          _createElementVNode("div", _hoisted_80, [
            _hoisted_81,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "input w-full border flex-1",
              placeholder: "url link img pertanyaan",
              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.exDataMS.questionImg) = $event))
            }, null, 512), [
              [_vModelText, _ctx.exDataMS.questionImg]
            ])
          ]),
          (_ctx.exDataMS.questionImg)
            ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                _createElementVNode("img", {
                  class: "w-full md:w-auto mx-auto",
                  src: _ctx.exDataMS.questionImg,
                  alt: _ctx.exDataMS.questionImg
                }, null, 8, _hoisted_83)
              ]))
            : _createCommentVNode("", true),
          _hoisted_84,
          _createElementVNode("ol", _hoisted_85, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.exDataMS.option, (opt, idx) => {
              return (_openBlock(), _createElementBlock("li", {
                key: idx,
                class: "py-3 pt-2 border-b border-green-400"
              }, [
                _createElementVNode("div", _hoisted_86, [
                  _createElementVNode("div", _hoisted_87, [
                    _hoisted_88,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "input pl-16 md:pl-20 w-full border col-span-4",
                      placeholder: "A",
                      "onUpdate:modelValue": ($event: any) => ((opt.option) = $event),
                      disabled: ""
                    }, null, 8, _hoisted_89), [
                      [_vModelText, opt.option]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_90, [
                    _hoisted_91,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "input pl-24 w-full border col-span-4",
                      placeholder: "10",
                      "onUpdate:modelValue": ($event: any) => ((opt.poin) = $event)
                    }, null, 8, _hoisted_92), [
                      [_vModelText, opt.poin]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_93, [
                  _hoisted_94,
                  _createElementVNode("div", _hoisted_95, [
                    _createVNode(_component_CKEditor, {
                      modelValue: opt.text,
                      "onUpdate:modelValue": ($event: any) => ((opt.text) = $event),
                      editor: _ctx.classicEditor,
                      config: _ctx.editorConfig,
                      placeholder: "Kontent Opsi"
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "editor", "config"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_96, [
                  _hoisted_97,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "input w-full border flex-1",
                    placeholder: "url link Image Opsi",
                    "onUpdate:modelValue": ($event: any) => ((opt.img) = $event)
                  }, null, 8, _hoisted_98), [
                    [_vModelText, opt.img]
                  ])
                ]),
                (opt.img)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                      _createElementVNode("img", {
                        class: "w-full md:w-auto mx-auto",
                        src: opt.img,
                        alt: opt.img
                      }, null, 8, _hoisted_100)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_101, [
            _hoisted_102,
            _createElementVNode("div", _hoisted_103, [
              _createVNode(_component_CKEditor, {
                modelValue: _ctx.exDataMS.pembahasan,
                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.exDataMS.pembahasan) = $event)),
                editor: _ctx.classicEditor,
                config: _ctx.editorConfig,
                placeholder: "Pembahasan"
              }, null, 8, ["modelValue", "editor", "config"])
            ])
          ]),
          _createElementVNode("div", _hoisted_104, [
            _hoisted_105,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "input w-full border flex-1",
              placeholder: "url link img pembahasan",
              "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.exDataMS.pembahasanImg) = $event))
            }, null, 512), [
              [_vModelText, _ctx.exDataMS.pembahasanImg]
            ])
          ]),
          (_ctx.exDataMS.pembahasanImg)
            ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
                _createElementVNode("img", {
                  class: "w-full md:w-auto mx-auto",
                  src: _ctx.exDataMS.pembahasanImg,
                  alt: _ctx.exDataMS.pembahasanImg
                }, null, 8, _hoisted_107)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_108, [
            _hoisted_109,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "input w-full border flex-1",
              placeholder: "A",
              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.exDataMS.answer) = $event))
            }, null, 512), [
              [_vModelText, _ctx.exDataMS.answer]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_110, [
          _createElementVNode("button", {
            type: "button",
            class: "button w-20 bg-theme-6 text-white mr-2",
            onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.$gpf.hideModal('#modal-data-bs')))
          }, " Close "),
          (_ctx.section === 'add')
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "button w-20 bg-theme-1 text-white",
                onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.addMSApi()))
              }, " Simpan "))
            : _createCommentVNode("", true),
          (_ctx.section === 'edit')
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                class: "button w-20 bg-theme-1 text-white",
                onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.editMSApi()))
              }, " Update "))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_111, [
      _createElementVNode("div", _hoisted_112, [
        _createElementVNode("div", _hoisted_113, [
          _createVNode(_component_xCircleIcon, { class: "w-16 h-16 text-theme-6 mx-auto mt-3" }),
          _hoisted_114,
          _createElementVNode("div", _hoisted_115, " Ingin menghapus data dengan Pertanyaan : \"" + _toDisplayString(_ctx.exDeleteMS.question.slice(0, 200)) + " ...\"\". ", 1)
        ]),
        _createElementVNode("div", _hoisted_116, [
          _createElementVNode("button", {
            type: "button",
            "data-dismiss": "modal",
            class: "button w-24 border text-gray-700 dark:border-dark-5 dark:text-gray-300 mr-1",
            onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.$gpf.hideModal('#delete-modal-data-ms')))
          }, " Cancel "),
          _createElementVNode("button", {
            type: "button",
            class: "button w-24 bg-theme-6 text-white",
            onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.deleteMSApi()))
          }, " Delete ")
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_117, [
      _createElementVNode("div", _hoisted_118, [
        _createElementVNode("div", _hoisted_119, [
          _hoisted_120,
          _createElementVNode("a", {
            href: "javascript:;",
            class: "right-0 top-0",
            onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.$gpf.hideModal('#modal-detail-bs')))
          }, [
            _createVNode(_component_xIcon, { class: "w-6 h-6 text-gray-500" })
          ])
        ]),
        _createElementVNode("div", _hoisted_121, [
          _createElementVNode("div", _hoisted_122, [
            _hoisted_123,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "input w-full border flex-1",
              placeholder: "url link img pertanyaan",
              disabled: "",
              "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.detailMS.jenis) = $event))
            }, null, 512), [
              [_vModelText, _ctx.detailMS.jenis]
            ])
          ]),
          _createElementVNode("div", _hoisted_124, [
            _hoisted_125,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "input w-full border flex-1",
              placeholder: "url link img pertanyaan",
              disabled: "",
              "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.detailMS.kategori) = $event))
            }, null, 512), [
              [_vModelText, _ctx.detailMS.kategori]
            ])
          ]),
          _createElementVNode("div", _hoisted_126, [
            _hoisted_127,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "input w-full border flex-1",
              placeholder: "url link img pertanyaan",
              disabled: "",
              "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.detailMS.bidang) = $event))
            }, null, 512), [
              [_vModelText, _ctx.detailMS.bidang]
            ])
          ]),
          _createElementVNode("div", _hoisted_128, [
            _hoisted_129,
            _createElementVNode("div", {
              class: "input w-full border flex-1",
              innerHTML: _ctx.detailMS.question || '-'
            }, null, 8, _hoisted_130)
          ]),
          _createElementVNode("div", _hoisted_131, [
            _hoisted_132,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "input w-full border flex-1",
              placeholder: "url link img pertanyaan",
              disabled: "",
              "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.detailMS.questionImg) = $event))
            }, null, 512), [
              [_vModelText, _ctx.detailMS.questionImg]
            ])
          ]),
          (_ctx.detailMS.questionImg)
            ? (_openBlock(), _createElementBlock("div", _hoisted_133, [
                _createElementVNode("img", {
                  class: "w-full md:w-auto mx-auto",
                  src: _ctx.detailMS.questionImg,
                  alt: _ctx.detailMS.questionImg,
                  "data-action": "zoom"
                }, null, 8, _hoisted_134)
              ]))
            : _createCommentVNode("", true),
          _hoisted_135,
          _createElementVNode("ol", _hoisted_136, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailMS.options, (opt, idx) => {
              return (_openBlock(), _createElementBlock("li", {
                key: idx,
                class: "py-3 pt-2 border-b border-green-400"
              }, [
                _createElementVNode("div", _hoisted_137, [
                  _createElementVNode("div", _hoisted_138, [
                    _hoisted_139,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "input pl-16 md:pl-20 w-full border col-span-4",
                      placeholder: "A",
                      "onUpdate:modelValue": ($event: any) => ((opt.option) = $event),
                      disabled: ""
                    }, null, 8, _hoisted_140), [
                      [_vModelText, opt.option]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_141, [
                    _hoisted_142,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "input pl-24 w-full border col-span-4",
                      placeholder: "10",
                      disabled: "",
                      "onUpdate:modelValue": ($event: any) => ((opt.poin) = $event)
                    }, null, 8, _hoisted_143), [
                      [_vModelText, opt.poin]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_144, [
                  _hoisted_145,
                  _createElementVNode("div", {
                    class: "input w-full border flex-1",
                    innerHTML: opt.text || '-'
                  }, null, 8, _hoisted_146)
                ]),
                _createElementVNode("div", _hoisted_147, [
                  _hoisted_148,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "input w-full border flex-1",
                    placeholder: "url link Image Opsi",
                    disabled: "",
                    "onUpdate:modelValue": ($event: any) => ((opt.img) = $event)
                  }, null, 8, _hoisted_149), [
                    [_vModelText, opt.img]
                  ])
                ]),
                (opt.img)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_150, [
                      _createElementVNode("img", {
                        class: "w-full md:w-auto mx-auto",
                        src: opt.img,
                        alt: opt.img
                      }, null, 8, _hoisted_151)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_152, [
            _hoisted_153,
            _createElementVNode("div", {
              class: "input w-full border flex-1",
              innerHTML: _ctx.detailMS.pembahasan || '-'
            }, null, 8, _hoisted_154)
          ]),
          _createElementVNode("div", _hoisted_155, [
            _hoisted_156,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "input w-full border flex-1",
              placeholder: "url link img pembahasan",
              disabled: "",
              "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.detailMS.pembahasanImg) = $event))
            }, null, 512), [
              [_vModelText, _ctx.detailMS.pembahasanImg]
            ])
          ]),
          (_ctx.detailMS.pembahasanImg)
            ? (_openBlock(), _createElementBlock("div", _hoisted_157, [
                _createElementVNode("img", {
                  class: "w-full md:w-auto mx-auto",
                  src: _ctx.detailMS.pembahasanImg,
                  alt: _ctx.detailMS.pembahasanImg
                }, null, 8, _hoisted_158)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_159, [
            _hoisted_160,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "input w-full border flex-1",
              placeholder: "A",
              disabled: "",
              "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.detailMS.answer) = $event))
            }, null, 512), [
              [_vModelText, _ctx.detailMS.answer]
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_importExcelFunc, { onImportExcelFunc: _ctx.importExcelFunc }, null, 8, ["onImportExcelFunc"])
  ]))
}